import axios from "axios";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

export interface IBrokerAnalyzerPreferencesState {
  loading: boolean;
  preferences: any[];
  selectedPreference: any;
}

const initialState: IBrokerAnalyzerPreferencesState = {
  loading: false,
  preferences: [],
  selectedPreference: null,
};

export const ACTION_TYPES = {
  FETCH_PREFERENCES_LIST: "brokerAnalyzerPreferences/FETCH_PREFERENCES_LIST",
  FETCH_BROKER_PREFERENCE: "brokerAnalyzerPreferences/FETCH_BROKER_PREFERENCE",
  SAVE_BROKER_PREFERENCE: "brokerAnalyzerPreferences/SAVE_BROKER_PREFERENCE",
};

export default (state = initialState, action): IBrokerAnalyzerPreferencesState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_PREFERENCES_LIST):
    case PENDING(ACTION_TYPES.FETCH_BROKER_PREFERENCE):
    case PENDING(ACTION_TYPES.SAVE_BROKER_PREFERENCE):
      return { ...state, loading: true };

    case FULFILLED(ACTION_TYPES.FETCH_PREFERENCES_LIST):
      return { ...state, loading: false, preferences: action.payload.data.selectPreferencesTypeList || [] };

    case FULFILLED(ACTION_TYPES.FETCH_BROKER_PREFERENCE):
      return {
        ...state,
        loading: false,
        selectedPreference: action.payload.data.preferenceID,
        preferences: action.payload.data.selectPreferencesTypeList || [],
      };

    case REJECTED(ACTION_TYPES.FETCH_PREFERENCES_LIST):
    case REJECTED(ACTION_TYPES.FETCH_BROKER_PREFERENCE):
      return { ...state, loading: false };

    default:
      return state;
  }
};

export const fetchAnalyzerPreferenceOptions = () => ({
  type: ACTION_TYPES.FETCH_PREFERENCES_LIST,
  payload: axios.get(`brokers/analyzerPreferences/new`),
});

export const fetchBrokerAnalyzerPreference = (brokerID: number) => ({
  type: ACTION_TYPES.FETCH_BROKER_PREFERENCE,
  payload: axios.get(`brokers/${brokerID}/analyzerPreferences`),
});

export const saveBrokerAnalyzerPreference = (brokerID: number, preferenceValue: number = 1) => ({
  type: ACTION_TYPES.SAVE_BROKER_PREFERENCE,
  payload: axios.post(`brokers/${brokerID}/analyzerPreferences`, preferenceValue, {
    headers: { "Content-Type": "application/json" },
  }),
});
